import { SUBJECT_TYPES } from '@/modules/Education/Teach/constants';

/**
 * Действия в системе ведения уроков
 * Имеет 2 типа - консультация, проверка задания
*/
export default class Action {
  constructor({
    task,
    group,
    chatId,

    course,
    unit,
    lesson,

    user,
    date,

    type,
    subjectType,
  }) {
    this.group = group;
    this.task = task;
    this.chatId = chatId;

    this.course = course;
    this.unit = unit;
    this.lesson = lesson;

    this.user = user;
    this.date = date;

    // Проверка задания/консультация
    this.type = type;
    this.setupSubjectType(subjectType);
  }

  get id() {
    return `${this.type}${this.lesson?.id}${this.unit?.id}${this.course?.id}`;
  }

  setupSubjectType(subjectType) {
    let value = subjectType;

    if (!value) {
      // Автоопределение
      if (this.lesson) value = SUBJECT_TYPES.lesson;
      else if (!this.lesson && this.unit) value = SUBJECT_TYPES.unit;
      else value = SUBJECT_TYPES.course;
    }

    this.subjectType = value;
  }

  getName() {
    const NAMES = {
      [SUBJECT_TYPES.lesson]: `Консультация по уроку «${this.lesson?.title}»`,
      [SUBJECT_TYPES.unit]: `Консультация по теме «${this.unit?.title}»`,
      [SUBJECT_TYPES.course]: `Консультация по курсовой работе «${this.course.title}»`,
    };
    return NAMES[this.subjectType];
  }

  getTag() {
    return {
      course_id: this.course.id,
      course_unit_id: this.unit?.id,
      lesson_id: this.lesson?.id,
    };
  }
}
